import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../_actions';
import LoadingOverlay from 'react-loading-overlay';
import { CgLogIn } from 'react-icons/cg';
import { BiArrowBack } from "react-icons/bi";
import 'react-confirm-alert/src/react-confirm-alert.css';
// import './style.css'

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVideo: false,
      isVideoUpdate: false,
      userRowData: {},
      fieldsQuote: {},
      errorsQuote: {},
      fieldsUserUpdate: {},
      fieldsUserPasswordUpdate: {},
      errorsUpdateQuote: {},
      errorsUpdatePassword: {},
      viewRowData: {},
      type: null,
      gameType: null,
      rankType: null,
      addQuoteModal: false,
      moreDetailsCreateModal: false,
      UpdateQuoteCreateModal: false,
      loginToThisAccountModal: false,
      creditActivityOpenModal: false,
      creditpasswordOpenModal: false,
      // fieldsUserUpdate: {},
      fieldsUser: {},
      // errorsUpdateQuote: {},
      errorsUpdate: {},
      AddBalanceModal: false,
      // addQuoteModal: false,
      DeductBalanceModal: false,
      balance: '',
      offset: 0,
      size: 10,
      pageNo: 1,
      keyWord: '',
      updatePwdformData: {
        "id": "",
        "password": ""
      }
    }
  }
  componentDidMount() {
    let reqData = {
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.users.addUserSuccess) {
      return {
        ...nextProps,
        fieldsUserUpdate: {},
        fieldsQuote: {},
        fieldsUserPasswordUpdate: {},
        errorsUpdateQuote: {},
        errorsUpdatePassword: {},
        UpdateQuoteCreateModal: false,
        creditpasswordOpenModal: false,
        creditActivityOpenModal: false,
        addQuoteModal: false,
        fieldsUser: {},
        errorsUpdateQuoteAdd: {},
        errorsUpdate: {},
        AddBalanceModal: false,
        // addQuoteModal: false,
        DeductBalanceModal: false,
        balance: '',
        idParam: '',
        fieldsUserdeduct: ''

      }
    } else {
      return {
        ...nextProps,

      }
    }
  }




  inputAddUserChange = (e) => {
    // console.log(e.target.name, 'e___________________________', e.target.value);
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsQuote = this.state.fieldsQuote;
    let errorsQuote = this.state.errorsQuote;
    fieldsQuote[name] = value;
    // console.log(name, value);
    errorsQuote[name] = "";
    this.setState({ fieldsQuote, errorsQuote });
  }

  submitChangePassword = () => {
    if (this.handleValidationAddUser()) {
      let reqData = {
        "newpassword": this.state.fieldsQuote.newpassword,
        "confirmnewpassword": this.state.fieldsQuote.confirmnewpassword,
        "currentpassword": this.state.fieldsQuote.currentpassword,
      }

      this.props.dispatch(userActions.changePassword(reqData, this.props));
    }
  }

  handleValidationAddUser = () => {
    let fieldsQuote = this.state.fieldsQuote;
    let errorsQuote = {};
    let formIsValid = true;

    //currentpassword
    if (!fieldsQuote["currentpassword"] || fieldsQuote["currentpassword"] === "") {
      formIsValid = false;
      errorsQuote["currentpassword"] = "Current Password can not be empty";
    }

    // newpassword
    if (!fieldsQuote["newpassword"] || fieldsQuote["newpassword"] === "") {
      formIsValid = false;
      errorsQuote["newpassword"] = "Cannot be empty";
    }

    // confirmnewpassword
    if (!fieldsQuote["confirmnewpassword"] || fieldsQuote["confirmnewpassword"] === "") {
      formIsValid = false;
      errorsQuote["confirmnewpassword"] = "Cannot be empty";
    }
    console.log('errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote', errorsQuote);
    this.setState({ errorsQuote: errorsQuote });
    return formIsValid;
  }

  handleGoBack = () => {
    this.props.history.goBack();
  };

  render() {

    let { users, membership, trainer, sales, banner } = this.props;
    let { filesDetails, loading } = users;

    return (

      <>
        <div>
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>

        <section className="relative overflow-y-auto text-gray-600 bg-white body-font">
          <div className="p-6">
            {/* <div className="flex flex-col w-full px-4 py-3 text-left bg-gray-100 bg-opacity-50 rounded-md">
              <h1 className="text-2xl font-medium text-indigo-600 sm:text-3xl title-font">Change Password</h1>

            </div> */}
            <div className="flex space-x-6">
              <div onClick={this.handleGoBack} className='p-1 text-gray-600 border border-gray-400 rounded-full cursor-pointer hover:bg-blue-400 hover:border-blue-400 hover:text-white'><BiArrowBack className='w-6 h-6' /></div>
              <h3 className="font-medium text-xl text-[#3D405B] whitespace-nowrap capitalize">Change Password</h3>
            </div>
            <div className="w-full py-6">

              <div className="grid flex-wrap grid-cols-1 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1">
                <div className="w-full p-2">
                  <div className="relative">
                    <label htmlFor="name" className="text-sm leading-7 text-gray-600">
                      Current Password
                    </label>
                    <input className={`w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out   ${this.state.errorsQuote && !this.state.errorsQuote["currentpassword"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                      id="currentpassword" name="currentpassword" placeholder="Confirm Password" value={this.state.fieldsQuote && this.state.fieldsQuote.currentpassword ? this.state.fieldsQuote.currentpassword : ''} type="text" onChange={this.inputAddUserChange} />
                    {this.state.errorsQuote && this.state.errorsQuote["currentpassword"] ?
                      <div className="text-xs text-red-500 invalid-feedback">
                        {this.state.errorsQuote["currentpassword"]}
                      </div>
                      : null}
                  </div>
                </div>
                <div className="w-full p-2">
                  <div className="relative">
                    <label htmlFor="name" className="text-sm leading-7 text-gray-600">
                      New Password
                    </label>
                    <input className={`w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out   ${this.state.errorsQuote && !this.state.errorsQuote["password"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                      id="newpassword" name="newpassword" placeholder="New Password" value={this.state.fieldsQuote && this.state.fieldsQuote.newpassword ? this.state.fieldsQuote.newpassword : ''} type="text" onChange={this.inputAddUserChange} />
                    {this.state.errorsQuote && this.state.errorsQuote["newpassword"] ?
                      <div className="text-xs text-red-500 invalid-feedback">
                        {this.state.errorsQuote["newpassword"]}
                      </div>
                      : null}
                  </div>
                </div>
                <div className="w-full p-2">
                  <div className="relative">
                    <label htmlFor="name" className="text-sm leading-7 text-gray-600">
                      Confirm Password
                    </label>
                    <input className={`w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out   ${this.state.errorsQuote && !this.state.errorsQuote["confirmnewpassword"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                      id="confirmnewpassword" name="confirmnewpassword" placeholder="Confirm Password" value={this.state.fieldsQuote && this.state.fieldsQuote.confirmnewpassword ? this.state.fieldsQuote.confirmnewpassword : ''} type="text" onChange={this.inputAddUserChange} />
                    {this.state.errorsQuote && this.state.errorsQuote["confirmnewpassword"] ?
                      <div className="text-xs text-red-500 invalid-feedback">
                        {this.state.errorsQuote["confirmnewpassword"]}
                      </div>
                      : null}
                  </div>
                </div>
              </div>

              <div className="flex justify-end py-0 mt-8 space-x-4">
                <button className="bg-blue-500 transition duration-150 text-white text-[.8125rem]  px-3 py-2 rounded-[.25rem] flex items-center hover:bg-[#f14646] " type="button" onClick={this.submitChangePassword}>Submit<CgLogIn size={22} className="ml-2" /></button>
              </div>

            </div>
          </div>
        </section>
      </>

    );
  }
}
function mapStateToProps(state) {
  const { users, membership, trainer, sales, banner } = state;
  return {
    users, membership, trainer, sales, banner
  };
}
export default connect(mapStateToProps)(ChangePassword);
